// extracted by mini-css-extract-plugin
export default {"FormWrapper":"customer-contact_FormWrapper__wWdtz"};